import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileCreateZipMutationAtom = createMutationAtomFactory(
  'files.createZip',
  ({ fileIds, archiveName }: { fileIds: string[]; archiveName: string }) => ({
    filesCreateZipArchive: {
      __args: {
        fileIds,
        archiveName,
      },
      downloadUrl: true,
      expiresAt: true,
      fileName: true,
      estimatedSize: true,
    },
  }),
);
